<div class="user" [class.deactivated]="isDeactivated">
  <craft-user-icon class="icon" [user]="user"></craft-user-icon>
  <div class="ellipsis">
    <div class="name-line">
      <span [matTooltip]="user | fullName" [matTooltipShowDelay]="1000" class="name ellipsis">{{ user | fullName }}</span>
      <span class="deactivated-label" *ngIf="isDeactivated">(Deactivated)</span>
    </div>
    <div [matTooltip]="user.email || ''" [matTooltipShowDelay]="1000" class="email ellipsis">{{ user.email }}</div>
  </div>
</div>
